import { useMutation } from '@tanstack/vue-query'
import { downloadFiatTransactions } from './fiatTransactionsEndpoints'
import { downloadFiatTransactionsCsv } from '../utils/downloadFiatTransactionsCsv'
import type { GetFiatTransactionsParams } from '../types/fiatTransactionsTypes'

/**
 * Hits the CSV download endpoint with the given filter params, receives
 * a Blob response, and triggers the browser download via the kit's
 * `downloadBlob` (a synthetic anchor click + object URL revoke).
 *
 * Errors from the BE — including `FIAT_TRANSACTIONS_DOWNLOAD_LIMIT_EXCEEDED`
 * when the result set exceeds the 50k-row safety cap — surface on the
 * mutation's reactive `.error`. The container subscribes and shows a toast.
 */
export function useDownloadFiatTransactionsMutation() {
  return useMutation({
    mutationFn: async (params: GetFiatTransactionsParams) => {
      const blob = await downloadFiatTransactions(params)
      downloadFiatTransactionsCsv(blob)
    },
  })
}
